import NProgress from 'nprogress'
import { cssAnimationAttr, lazyImageAttr, loadingClass } from './_constants'
import lazyLoad from './lazyLoad'
import cssAnimationObserver from './cssAnimationsObserver'

export default function shuffleLoadMore(page, shuffle, container) {
  const loadMoreButton = page.querySelector('[data-shuffle-load]')
  let currentPage = 0
  let totalPages = null
  let allItemsInGrid = 0

  const fetchContent = () => {
    currentPage += 1
    NProgress.start()

    fetch(`${container.dataset.route}/${currentPage}`)
      .then(res => res.json())
      .then(data => {
        const { total, html } = data

        if (!totalPages) {
          totalPages = +total
        }

        allItemsInGrid = Array.from(container.children)
        container.insertAdjacentHTML('beforeend', html.toString())

        const newItems = [...container.children].slice(
          -(container.children.length - allItemsInGrid.length)
        )

        newItems.forEach(el => {
          lazyLoad.observe(el.querySelector(lazyImageAttr))
          cssAnimationObserver.observe(el.querySelector(cssAnimationAttr))
        })

        shuffle.add(newItems)
        shuffle.update()
        loadMoreButton.classList.remove(loadingClass)
        NProgress.done()

        if (currentPage === totalPages) {
          loadMoreButton.style.display = 'none'
        }
      })
  }

  loadMoreButton.addEventListener('click', () => {
    loadMoreButton.classList.add(loadingClass)
    fetchContent()
  })

  fetchContent()
}
